import { render } from "./ItemQuantitiesChart.vue?vue&type=template&id=39abff4a&scoped=true"
import script from "./ItemQuantitiesChart.vue?vue&type=script&lang=js"
export * from "./ItemQuantitiesChart.vue?vue&type=script&lang=js"

import "./ItemQuantitiesChart.vue?vue&type=style&index=0&id=39abff4a&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39abff4a"]])

export default __exports__